module.exports = __webpack_public_path__ + "static/media/FINE-BNB.58fc158a.svg";